import { SpentFormatter } from 'components/tables/NinjaTable/formatters';
import RoiFormatter from 'components/tables/NinjaTable/formatters/RoiFormatter';
import RoasFormatter from 'components/tables/NinjaTable/formatters/RoasFormatter';
import ValueDotFormatter from 'components/tables/NinjaTable/formatters/ValueDotFormatter';
import { RoiDefinition, RoasDefinition } from 'components/NameDefinition';

export const postbackMetrics = {
  ad_spent: {
    color: '#eb2f20',
    name: 'Ad Spent',
    formatter: SpentFormatter,
    show: true,
    type: 'bar',
    currency: true,
  },
  net_profit: {
    color: '#91c716',
    name: 'Net Profit',
    valueFormatter: ValueDotFormatter,
    show: true,
    currency: true,
    type: 'bar',
  },
  gross_income: {
    color: '#ffbb02',
    name: 'Gross Income',
    valueFormatter: ValueDotFormatter,
    currency: true,
    type: 'bar',
    show: true,
  },
  cpa: {
    color: '#91c716',
    name: 'CPA',
    show: true,
    type: 'bar',
  },
  cpl: {
    color: '#91c716',
    name: 'CPL',
    show: true,
    type: 'bar',
  },
  roi: {
    color: '#ff4e00',
    name: 'ROI',
    type: 'line',
    formatter: RoiFormatter,
    opacity: 0.7,
    symbol: '%',
    definition: RoiDefinition,
    show: true,
  },
  roas: {
    color: '#F09319',
    name: 'ROAS',
    type: 'line',
    formatter: RoasFormatter,
    opacity: 0.7,
    definition: RoasDefinition,
    show: true,
  },
  count: {
    color: '#536A8B',
    name: 'count',
    type: 'bar',
    show: true,
  },
};
